export enum PasswordStrength {
  TOO_SHORT = 'TOO_SHORT',
  WEAK = 'WEAK',
  MEDIUM = 'MEDIUM',
  STRONG = 'STRONG',
}
